import { map as _$ma, createElementVNode as _$ce, className as _$cn, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { Button } from '../button';
import { Icon } from '../icon';
import { _$ } from '../../i18n';
import { makeCalendarStyles } from './styles';
import { getNowDate } from './helpers';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var type = this.type.value;
  var isYear = type === 'year';
  var isYearOrMonth = isYear || type === 'month';
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-datepicker-calendar"] = true, _classNameObj[makeCalendarStyles(k)] = true, _classNameObj);
  var now = getNowDate();
  var _this$datepicker$focu = this.datepicker.focusDate,
    focusDate = _this$datepicker$focu.focusDate,
    resetFocusDate = _this$datepicker$focu.reset;
  var getItems = function getItems(data, onClick) {
    return _$ma(data, function ($value, $key) {
      var _$cn2;
      return _$ce(2, 'div', _$ce(2, 'div', $value.label, 0, _$cn(k + "-value")), 2, _$cn((_$cn2 = {}, _$cn2[k + "-calendar-item"] = true, _$cn2[k + "-exceed"] = $value.isExceed, _$cn2[k + "-active"] = $value.isActive, _$cn2[k + "-today"] = $value.isToday, _$cn2[k + "-disabled"] = $value.isDisabled, _$cn2[k + "-hover"] = $value.isHover, _$cn2[k + "-in-range"] = $value.isInRange, _$cn2)), {
        'ev-click': !$value.isDisabled ? function (e) {
          e._ignore = true;
          onClick($value.value);
        } : null,
        'ev-mouseenter': function evMouseenter() {
          return focusDate.set($value.value);
        }
      });
    }, $this);
  };
  var _this$days = this.days,
    getDays = _this$days.getDays,
    onClickDay = _this$days.onClick;
  var _this$showDate = this.showDate,
    getDateLabel = _this$showDate.getDateLabel,
    prevMonth = _this$showDate.prevMonth,
    nextMonth = _this$showDate.nextMonth,
    prevYear = _this$showDate.prevYear,
    nextYear = _this$showDate.nextYear,
    prevTenYears = _this$showDate.prevTenYears,
    nextTenYears = _this$showDate.nextTenYears;
  return _$ce(2, 'div', [_$ce(2, 'div', [_$ce(2, 'div', [_$cc(Button, {
    'icon': true,
    'type': 'none',
    'size': 'small',
    'className': _$cn(k + "-prev"),
    'tagName': 'div',
    'ev-click': isYear ? prevTenYears : prevYear,
    'children': [_$cc(Icon, {
      'className': _$cn(k + "-icon-left"),
      'size': 'small'
    }), _$cc(Icon, {
      'className': _$cn(k + "-icon-left"),
      'size': 'small'
    })]
  }), !isYearOrMonth ? _$cc(Button, {
    'icon': true,
    'type': 'none',
    'size': 'small',
    'className': _$cn(k + "-prev"),
    'tagName': 'div',
    'ev-click': prevMonth,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-left"),
      'size': 'small'
    })
  }) : undefined], 0, _$cn(k + "-left-btns")), _$ce(2, 'div', !isYear ? _$ma(getDateLabel(), function ($value, $key) {
    return _$ce(2, 'span', $value.value, 0, _$cn(k + "-month-value"), {
      'ev-click': $value.onClick
    });
  }, $this) : _$ce(2, 'span', this.years.getYearLabel(), 0, _$cn(k + "-month-value")), 0, _$cn(k + "-month-values")), _$ce(2, 'div', [!isYearOrMonth ? _$cc(Button, {
    'icon': true,
    'type': 'none',
    'size': 'small',
    'className': _$cn(k + "-next"),
    'tagName': 'div',
    'ev-click': nextMonth,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-right"),
      'size': 'small'
    })
  }) : undefined, _$cc(Button, {
    'icon': true,
    'type': 'none',
    'size': 'small',
    'className': _$cn(k + "-next"),
    'tagName': 'div',
    'ev-click': isYear ? nextTenYears : nextYear,
    'children': [_$cc(Icon, {
      'className': _$cn(k + "-icon-right"),
      'size': 'small'
    }), _$cc(Icon, {
      'className': _$cn(k + "-icon-right"),
      'size': 'small'
    })]
  })], 0, _$cn(k + "-right-btns"))], 4, _$cn(k + "-datepicker-month")), !isYearOrMonth ? [_$ce(2, 'div', _$ma([_$('日'), _$('一'), _$('二'), _$('三'), _$('四'), _$('五'), _$('六')], function ($value, $key) {
    return _$ce(2, 'div', $value, 0, _$cn(k + "-weekday"));
  }, $this), 4, _$cn(k + "-weekdays")), _$ce(2, 'div', getItems(getDays(now), onClickDay), 0, _$cn(k + "-days"), {
    'ev-mouseleave': resetFocusDate
  })] : _$ce(2, 'div', isYear ? getItems(this.years.getYears(now), this.years.onClick) : getItems(this.months.getMonths(now), this.months.onClick), 0, _$cn(k + "-years"), {
    'ev-mouseleave': resetFocusDate
  })], 0, _$cn(classNameObj));
}
;